import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './ean.reducer';

export const EanDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const eanEntity = useAppSelector(state => state.ean.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="eanDetailsHeading">
          <Translate contentKey="crawlerBackendApp.ean.detail.title">Ean</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{eanEntity.id}</dd>
          <dt>
            <span id="eanCode">
              <Translate contentKey="crawlerBackendApp.ean.eanCode">Ean Code</Translate>
            </span>
          </dt>
          <dd>{eanEntity.eanCode}</dd>
          <dt>
            <span id="switchingStatus">
              <Translate contentKey="crawlerBackendApp.ean.switchingStatus">Switching Status</Translate>
            </span>
          </dt>
          <dd>{eanEntity.switchingStatus}</dd>
          <dt>
            <span id="isResidential">
              <Translate contentKey="crawlerBackendApp.ean.isResidential">Is Residential</Translate>
            </span>
          </dt>
          <dd>{eanEntity.isResidential ? 'true' : 'false'}</dd>
          <dt>
            <span id="isComplex">
              <Translate contentKey="crawlerBackendApp.ean.isComplex">Is Complex</Translate>
            </span>
          </dt>
          <dd>{eanEntity.isComplex ? 'true' : 'false'}</dd>
          <dt>
            <span id="isSmartMeter">
              <Translate contentKey="crawlerBackendApp.ean.isSmartMeter">Is Smart Meter</Translate>
            </span>
          </dt>
          <dd>{eanEntity.isSmartMeter ? 'true' : 'false'}</dd>
          <dt>
            <span id="gridArea">
              <Translate contentKey="crawlerBackendApp.ean.gridArea">Grid Area</Translate>
            </span>
          </dt>
          <dd>{eanEntity.gridArea}</dd>
          <dt>
            <span id="bagId">
              <Translate contentKey="crawlerBackendApp.ean.bagId">Bag Id</Translate>
            </span>
          </dt>
          <dd>{eanEntity.bagId}</dd>
          <dt>
            <span id="bagBuildingId">
              <Translate contentKey="crawlerBackendApp.ean.bagBuildingId">Bag Building Id</Translate>
            </span>
          </dt>
          <dd>{eanEntity.bagBuildingId}</dd>
          <dt>
            <span id="activeMeterNumber">
              <Translate contentKey="crawlerBackendApp.ean.activeMeterNumber">Active Meter Number</Translate>
            </span>
          </dt>
          <dd>{eanEntity.activeMeterNumber}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.ean.gridOperator">Grid Operator</Translate>
          </dt>
          <dd>{eanEntity.gridOperator ? eanEntity.gridOperator.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/ean" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/ean/${eanEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EanDetail;
